import styled, { keyframes } from 'styled-components';
import { Text } from '~/components/ui/Text';

const createRotateAnimation = (initialRotate: number) => keyframes`
    0% {
        transform: rotate(${initialRotate}deg);
    }
    100% {
        transform: rotate(${initialRotate + 360}deg);
    }
`;

const StyledContainer = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
`;

const StyledSvg = styled.svg`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
`;

const StyledInnerCircle = styled.circle<{
	$initialRotate: number;
	$speed: number;
}>`
	border-radius: 10px;
	transform-origin: center;
	animation: ${(props) => createRotateAnimation(props.$initialRotate)}
		${(props) => props.$speed}s linear infinite;
`;

const StyledCursor = styled.rect`
	transform-origin: 61px 60px;
	will-change: transform;
`;

const StyledControlsContainer = styled.div`
	position: absolute;
	bottom: 30px;
	right: 30px;
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	gap: 10px;
`;

const StyledPercent = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 20px;
	background-color: rgba(0, 0, 0, 0.5);
	border-radius: 5px;

	${Text} {
		font-weight: 500;
		font-size: 14px;
		color: #ffffff;
	}
`;

export {
	StyledContainer,
	StyledControlsContainer,
	StyledCursor,
	StyledInnerCircle,
	StyledPercent,
	StyledSvg,
};
